import {
  deleteAuthenticated,
  get,
  post,
  getAuthenticated,
  getUnauthenticated,
  postAuthenticated,
  postUnauthenticated,
  putAuthenticated,
} from "./HttpService";
import { queryAuthenticated, mutationAuthenticated } from "./GraphService";

const workspaceFetchUrl = process.env.REACT_APP_WORKSPACE_FETCH_URL;
const headers = {
  "Content-Type": "application/json",
};

async function proxies(workspace) {
  const url = `${workspaceFetchUrl}/${workspace}`;
  const response = await get(url);
  if (!response || !response?.engine?.host) {
    throw new Error(
      "No such workspace found! Please check the workspace name."
    );
  }
  return response;
}

async function authenticate(workspace, username, password) {
  const url = `${workspace.engine.scheme}://${workspace.engine.host}:${workspace.engine.port}${process.env.REACT_APP_API_PREFIX}/authenticate`;
  const body = {
    workspace: workspace.workspace_id,
    username: username,
    password: password,
  };
  const response = await post(url, body, headers);
  return response;
}

async function deauthenticate(workspace, username) {
  const url = `/logout`;
  const response = await postUnauthenticated(
    url,
    JSON.stringify({
      workspace,
      username,
    }),
    headers
  );
  return response;
}

async function vaildateToken(workspace, username, token) {
  return await postUnauthenticated(
    `/validate-token`,
    JSON.stringify({
      workspace,
      username,
      token,
    }),
    headers
  );
}

async function forgotPassword(workspace, username) {
  const response = await postUnauthenticated(
    `/forgot-password`,
    JSON.stringify({
      workspace,
      username,
    }),
    headers
  );
  return response;
}

async function resetPassword(workspace, username, newPassword, token) {
  const response = await postUnauthenticated(
    `/reset-password`,
    JSON.stringify({
      workspace,
      username,
      newPassword,
      token,
    }),
    headers
  );
  return response;
}

/** Plants */
async function getPlants(query, variables) {
  try {
    const response = await queryAuthenticated("/graphql", query, variables);
    return response.data.plants;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}

async function getPlant(plantId) {
  const response = await getAuthenticated(`/plants/${plantId}`);
  return response.payload;
}
async function createPlant() {
  const response = await postAuthenticated(`/plants`);
  return response.payload;
}

async function updatePlant(plant) {
  try {
    const response = plant?.id
      ? await putAuthenticated(
          `/plants/${plant.id}`,
          JSON.stringify({ payload: plant }),
          {
            "Content-Type": "application/json",
          }
        )
      : await postAuthenticated(
          `/plants`,
          { payload: plant },
          {
            "Content-Type": "application/json",
          }
        );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}

/***
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
/*****Start Zone*****/
async function getZone(plantId, zoneId, includes) {
  const meta = `${
    includes && includes.length > 0 ? `?meta=${JSON.stringify(includes)}` : ``
  }`;
  const response = await getAuthenticated(
    `/plants/${plantId}/zones/${zoneId}${meta}`
  );
  return response.payload;
}
async function saveZone(plantId, zone) {
  try {
    zone.plant_id = plantId;
    const response = zone?.id
      ? await putAuthenticated(
          `/plants/${plantId}/zones/${zone.id}`,
          JSON.stringify({ payload: zone }),
          {
            "Content-Type": "application/json",
          }
        )
      : await postAuthenticated(
          `/plants/${plantId}/zones`,
          JSON.stringify({ payload: zone }),
          {
            "Content-Type": "application/json",
          }
        );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getZones(plantId, includes) {
  try {
    let url = `/plants/${plantId}/zones`;
    if (includes && includes.length > 0) {
      url += `?meta=${encodeURI(JSON.stringify(includes))}`;
    }
    const response = await getAuthenticated(url);
    return response.payload.data;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function deleteZone(plantId, zoneId) {
  try {
    const response = await deleteAuthenticated(
      `/plants/${plantId}/zones/${zoneId}`,
      {
        "Content-Type": "application/json",
      }
    );
    return response;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getZoneLinkedDevices(plantId, zoneId) {
  try {
    const response = await getAuthenticated(
      `/plants/${plantId}/zones/${zoneId}/installations`
    );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function addDeviceWithZone(plantId, zoneId, request) {
  try {
    const response = await putAuthenticated(
      `/plants/${plantId}/zones/${zoneId}/installations`,
      JSON.stringify(request),
      {
        "Content-Type": "application/json",
      }
    );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function removeDeviceWithZone(plantId, zoneId, request) {
  try {
    const response = await putAuthenticated(
      `/plants/${plantId}/zones/${zoneId}/installations`,
      JSON.stringify(request),
      {
        "Content-Type": "application/json",
      }
    );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
/*****End Zone*****/

/*****Device Start*****/
async function getDevice(plantId, deviceId, includes) {
  const meta = `${
    includes && includes.length > 0 ? `?meta=${JSON.stringify(includes)}` : ``
  }`;
  const response = await getAuthenticated(
    `/plants/${plantId}/devices/${deviceId}${meta}`
  );
  return response.payload;
}
async function saveDevice(plantId, device) {
  try {
    device.plant_id = plantId;
    const response = device?.id
      ? await putAuthenticated(
          `/plants/${plantId}/devices/${device.id}`,
          JSON.stringify({ payload: device }),
          {
            "Content-Type": "application/json",
          }
        )
      : await postAuthenticated(
          `/plants/${plantId}/devices`,
          JSON.stringify({ payload: device }),
          {
            "Content-Type": "application/json",
          }
        );
    if (response.payload) return response.payload;
    else return response;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
    return error;
  }
}
async function getDevices(plantId) {
  try {
    const response = await getAuthenticated(`/plants/${plantId}/devices`);
    return response.payload.data;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function deleteDevice(plantId, deviceId) {
  try {
    const response = await deleteAuthenticated(
      `/plants/${plantId}/devices/${deviceId}`,
      {
        "Content-Type": "application/json",
      }
    );
    return response;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getDeviceLinkedZones(plantId, deviceId) {
  try {
    const response = await getAuthenticated(
      `/plants/${plantId}/devices/${deviceId}/installations`
    );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function addZoneWithDevice(plantId, deviceId, request) {
  try {
    const response = await putAuthenticated(
      `/plants/${plantId}/devices/${deviceId}/installations`,
      JSON.stringify(request),
      {
        "Content-Type": "application/json",
      }
    );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function removeZoneWithDevice(plantId, deviceId, request) {
  try {
    const response = await putAuthenticated(
      `/plants/${plantId}/devices/${deviceId}/installations`,
      JSON.stringify(request),
      {
        "Content-Type": "application/json",
      }
    );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
/*****End Device*****/

/*****Start Channel*****/
async function saveChannel(plantId, deviceId, channelId, request) {
  try {
    const response = await putAuthenticated(
      `/plants/${plantId}/devices/${deviceId}/channels/${channelId}`,
      JSON.stringify(request),
      {
        "Content-Type": "application/json",
      }
    );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getChannels(plantId, deviceId) {
  try {
    const response = await getAuthenticated(
      `/plants/${plantId}/devices/${deviceId}/channels`
    );
    return response.payload.data;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getChannel(plantId, deviceId, channelId) {
  try {
    const response = await getAuthenticated(
      `/plants/${plantId}/devices/${deviceId}/channels/${channelId}`
    );
    return response.payload.data;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
/*****End Channel*****/

/*****Start User*****/
async function getUser(userId, includes) {
  const meta = `${
    includes && includes.length > 0 ? `?meta=${JSON.stringify(includes)}` : ``
  }`;
  const response = await getAuthenticated(`/users/${userId}${meta}`);
  return response.payload;
}
async function saveUser(user) {
  try {
    const response = user?.id
      ? await putAuthenticated(
          `/users/${user.id}`,
          JSON.stringify({ payload: user }),
          {
            "Content-Type": "application/json",
          }
        )
      : await postAuthenticated(`/users`, JSON.stringify({ payload: user }), {
          "Content-Type": "application/json",
        });
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getUsers() {
  try {
    const response = await getAuthenticated(`/users`);
    return response.payload.data;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function deleteUser(userId) {
  try {
    const response = await deleteAuthenticated(`/users/${userId}`, {
      "Content-Type": "application/json",
    });
    return response;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getUserLinkedShifts(plantId, userId) {
  try {
    const response = await getAuthenticated(`/users/${userId}/shifts`);
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function addShiftWithUser(plantId, userId, request) {
  try {
    const response = await putAuthenticated(
      `/users/${userId}/shifts`,
      JSON.stringify(request),
      {
        "Content-Type": "application/json",
      }
    );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function removeShiftWithUser(plantId, userId, request) {
  try {
    const response = await putAuthenticated(
      `/users/${userId}/shifts`,
      JSON.stringify(request),
      {
        "Content-Type": "application/json",
      }
    );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getUserLinkedPlants(userId) {
  try {
    const response = await getAuthenticated(
      `/users/${userId}/memberships/plants`
    );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getUserLinkedRoles(userId) {
  try {
    const response = await getAuthenticated(
      `/users/${userId}/memberships/roles`
    );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function addUserWithPlantRole(userId, request) {
  try {
    const response = await putAuthenticated(
      `/users/${userId}/memberships/plants`,
      JSON.stringify(request),
      {
        "Content-Type": "application/json",
      }
    );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function removeUserWithPlantRole(userId, request) {
  try {
    const response = await putAuthenticated(
      `/users/${userId}/memberships/plants`,
      JSON.stringify(request),
      {
        "Content-Type": "application/json",
      }
    );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
/*****End User*****/

/*****Start Shift*****/
async function getShift(plantId, shiftId, includes) {
  const meta = `${
    includes && includes.length > 0 ? `?meta=${JSON.stringify(includes)}` : ``
  }`;

  const response = await getAuthenticated(
    `/plants/${plantId}/shifts/${shiftId}${meta}`
  );
  return response.payload;
}
async function saveShift(plantId, shift) {
  try {
    shift.plant_id = plantId;
    const response = shift?.id
      ? await putAuthenticated(
          `/plants/${plantId}/shifts/${shift.id}`,
          JSON.stringify({ payload: shift }),
          {
            "Content-Type": "application/json",
          }
        )
      : await postAuthenticated(
          `/plants/${plantId}/shifts`,
          JSON.stringify({ payload: shift }),
          {
            "Content-Type": "application/json",
          }
        );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getShifts(plantId, includes, sortOn, sortOrder) {
  try {
    const qsArray = [];
    if (includes && includes.length > 0) {
      qsArray.push(`meta=${JSON.stringify(includes)}`);
    }
    if (sortOn && sortOn.length > 0) {
      qsArray.push(`sort_on=${sortOn}`);
    }
    if (sortOrder && sortOrder.length > 0) {
      qsArray.push(`sort_order=${sortOrder}`);
    }
    const qs = qsArray.join("&");
    const response = await getAuthenticated(
      `/plants/${plantId}/shifts${qs.length > 0 ? `?${qs}` : ""}`
    );
    return response.payload.data;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getDynamicShifts(plantId) {
  try {
    const response = await postAuthenticated(
      `/plants/${plantId}/shifts/timeline`,
      JSON.stringify({ time: new Date(), number: 2 }),
      {
        "Content-Type": "application/json",
      }
    );
    console.log("timeline => ", response);
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function deleteShift(plantId, shiftId) {
  try {
    const response = await deleteAuthenticated(
      `/plants/${plantId}/shifts/${shiftId}`,
      {
        "Content-Type": "application/json",
      }
    );
    return response;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getShiftLinkedUsers(plantId, shiftId) {
  try {
    const response = await getAuthenticated(
      `/plants/${plantId}/shifts/${shiftId}/users`
    );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function addUserWithShift(plantId, shiftId, request) {
  try {
    const response = await putAuthenticated(
      `/plants/${plantId}/shifts/${shiftId}/users`,
      JSON.stringify(request),
      {
        "Content-Type": "application/json",
      }
    );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function removeUserWithShift(plantId, shiftId, request) {
  try {
    const response = await putAuthenticated(
      `/plants/${plantId}/shifts/${shiftId}/users`,
      JSON.stringify(request),
      {
        "Content-Type": "application/json",
      }
    );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
/*****End Shift*****/

/*****Start Role*****/
async function getRole(roleId, includes) {
  const meta = `${
    includes && includes.length > 0 ? `?meta=${JSON.stringify(includes)}` : ``
  }`;
  const response = await getAuthenticated(`/roles/${roleId}${meta}`);
  return response.payload;
}
async function saveRole(role) {
  try {
    const response = role?.id
      ? await putAuthenticated(
          `/roles/${role.id}`,
          JSON.stringify({ payload: role }),
          {
            "Content-Type": "application/json",
          }
        )
      : await postAuthenticated(`/roles`, JSON.stringify({ payload: role }), {
          "Content-Type": "application/json",
        });
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getRoles() {
  try {
    const response = await getAuthenticated(`/roles`);
    return response.payload.data;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function deleteRole(roleId) {
  try {
    const response = await deleteAuthenticated(`/roles/${roleId}`, {
      "Content-Type": "application/json",
    });
    return response;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getRoleLinkedPermissions(roleId) {
  try {
    const response = await getAuthenticated(`/roles/${roleId}/privileges`);
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function addPermissionWithRole(roleId, request) {
  try {
    const response = await putAuthenticated(
      `/roles/${roleId}/privileges`,
      JSON.stringify(request),
      {
        "Content-Type": "application/json",
      }
    );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
/*****End Role*****/

async function getTimeZones() {
  try {
    const response = await getAuthenticated("/timezones");
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}

/*****Start Device Profile*****/
async function getDeviceProfiles(plantId, includes) {
  try {
    const meta = `${
      includes && includes.length > 0 ? `?meta=${JSON.stringify(includes)}` : ``
    }`;
    const response = await getAuthenticated(
      `/plants/${plantId}/device-profiles${meta}`
    );
    return response.payload.data;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getDeviceProfile(plantId, deviceProfileId, includes) {
  const meta = `${
    includes && includes.length > 0 ? `?meta=${JSON.stringify(includes)}` : ``
  }`;
  const response = await getAuthenticated(
    `/plants/${plantId}/device-profiles/${deviceProfileId}${meta}`
  );
  return response.payload;
}
async function saveDeviceProfile(plantId, deviceProfile) {
  try {
    deviceProfile.plant_id = plantId;
    deviceProfile.configurator_type = 1;
    const response = deviceProfile?.id
      ? await putAuthenticated(
          `/plants/${plantId}/device-profiles/${deviceProfile.id}`,
          JSON.stringify({ payload: deviceProfile }),
          {
            "Content-Type": "application/json",
          }
        )
      : await postAuthenticated(
          `/plants/${plantId}/device-profiles`,
          JSON.stringify({ payload: deviceProfile }),
          {
            "Content-Type": "application/json",
          }
        );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function deleteDeviceProfile(plantId, deviceProfileId) {
  try {
    const response = await deleteAuthenticated(
      `/plants/${plantId}/device-profiles/${deviceProfileId}`,
      {
        "Content-Type": "application/json",
      }
    );
    return response;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
/*****End Device Profile*****/

/*****Start Setting*****/
async function getSettings(plantId) {
  try {
    const response = await getAuthenticated(`/plants/${plantId}/settings`);
    return response.payload.data;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getSetting(plantId, settingId) {
  const response = await getAuthenticated(
    `/plants/${plantId}/settings/${settingId}`
  );
  return response.payload;
}
async function saveSetting(plantId, setting) {
  try {
    const response = setting?.id
      ? await putAuthenticated(
          `/plants/${plantId}/settings/${setting.id}`,
          JSON.stringify({ payload: setting }),
          {
            "Content-Type": "application/json",
          }
        )
      : await postAuthenticated(
          `/plants/${plantId}/setting`,
          JSON.stringify({ payload: setting }),
          {
            "Content-Type": "application/json",
          }
        );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
/*****End Setting*****/

/*****Start Permission*****/
async function getPermissions() {
  try {
    const response = await getAuthenticated(`/permissions`);
    return response.payload.data;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
/*****End Permission*****/

/*****Start Part*****/
async function getPart(plantId, partId, includes) {
  const meta = `${
    includes && includes.length > 0 ? `?meta=${JSON.stringify(includes)}` : ``
  }`;
  const response = await getAuthenticated(
    `/plants/${plantId}/parts/${partId}${meta}`
  );
  return response.payload;
}
async function savePart(plantId, part) {
  try {
    part.plant_id = plantId;
    const response = part?.id
      ? await putAuthenticated(
          `/plants/${plantId}/parts/${part.id}`,
          JSON.stringify({ payload: part }),
          {
            "Content-Type": "application/json",
          }
        )
      : await postAuthenticated(
          `/plants/${plantId}/parts`,
          JSON.stringify({ payload: part }),
          {
            "Content-Type": "application/json",
          }
        );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getParts(plantId, query, variables) {
  try {
    const response = await queryAuthenticated("/graphql", query, variables);
    return response.data.parts;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function deletePart(plantId, partId) {
  try {
    const response = await deleteAuthenticated(
      `/plants/${plantId}/parts/${partId}`,
      {
        "Content-Type": "application/json",
      }
    );
    return response;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    } else {
      throw error;
    }
  }
}
/*****End Part*****/

/*****Start Search*****/
async function Search(plantId, text, includes) {
  try {
    const meta = `${
      includes && includes.length > 0 ? `&meta=${JSON.stringify(includes)}` : ``
    }`;
    const response = await getAuthenticated(
      `/plants/${plantId}/search?filter=${text}${meta}`
    );
    return response.payload.data;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
/*****End Search*****/

/*****Start Job Schedule*****/
async function getJobSchedules(plantId, includes) {
  try {
    const meta = `${
      includes && includes.length > 0 ? `?meta=${JSON.stringify(includes)}` : ``
    }`;
    const response = await getAuthenticated(
      `/plants/${plantId}/job-schedules${meta}`
    );
    return response.payload.data;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getJobSchedule(plantId, jobScheduleId, includes) {
  const meta = `${
    includes && includes.length > 0 ? `?meta=${JSON.stringify(includes)}` : ``
  }`;
  const response = await getAuthenticated(
    `/plants/${plantId}/job-schedules/${jobScheduleId}${meta}`
  );
  return response.payload;
}
async function saveJobSchedule(plantId, jobSchedule) {
  try {
    jobSchedule.plant_id = plantId;
    const response = jobSchedule?.id
      ? await putAuthenticated(
          `/plants/${plantId}/job-schedules/${jobSchedule.id}`,
          JSON.stringify({ payload: jobSchedule }),
          {
            "Content-Type": "application/json",
          }
        )
      : await postAuthenticated(
          `/plants/${plantId}/job-schedules`,
          JSON.stringify({ payload: jobSchedule }),
          {
            "Content-Type": "application/json",
          }
        );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function deleteJobSchedule(plantId, jobScheduleId) {
  try {
    const response = await deleteAuthenticated(
      `/plants/${plantId}/job-schedules/${jobScheduleId}`
    );
    return response;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getJobScheduleLinkedCycleStages(plantId, jobScheduleId) {
  try {
    const response = await getAuthenticated(
      `/plants/${plantId}/job-schedules/${jobScheduleId}/cycle-stages`,
      {
        "Content-Type": "application/json",
      }
    );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function addCycleStagesWithJobSchedule(
  plantId,
  jobScheduleId,
  cycleStages
) {
  try {
    const response = await putAuthenticated(
      `/plants/${plantId}/job-schedules/${jobScheduleId}/cycle-stages`,
      JSON.stringify({ payload: cycleStages }),
      {
        "Content-Type": "application/json",
      }
    );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
/*****End Job Schedule*****/

/*****Start Webhook*****/
async function getWebhook(webhookId, includes) {
  const meta = `${
    includes && includes.length > 0 ? `?meta=${JSON.stringify(includes)}` : ``
  }`;
  const response = await getAuthenticated(`/webhooks/${webhookId}${meta}`);
  return response.payload;
}
async function saveWebhook(webhook) {
  try {
    const response = webhook?.id
      ? await putAuthenticated(
          `/webhooks/${webhook.id}`,
          JSON.stringify({ payload: webhook }),
          {
            "Content-Type": "application/json",
          }
        )
      : await postAuthenticated(
          `/webhooks`,
          JSON.stringify({ payload: webhook }),
          {
            "Content-Type": "application/json",
          }
        );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getWebhooks(includes) {
  try {
    let url = `/webhooks`;
    if (includes && includes.length > 0) {
      url += `?meta=${encodeURI(JSON.stringify(includes))}`;
    }
    const response = await getAuthenticated(url);
    return response.payload.data;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function deleteWebhook(webhookId) {
  try {
    const response = await deleteAuthenticated(`/webhooks/${webhookId}`, {
      "Content-Type": "application/json",
    });
    return response;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
/*****End Webhook*****/

/*****Start Types*****/
async function getTypes() {
  try {
    let url = `/types`;
    const response = await getAuthenticated(url);
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
/*****End Types*****/

/*****Start Cycle*****/
async function getCycle(plantId, cycleId, includes) {
  const meta = `${
    includes && includes.length > 0 ? `?meta=${JSON.stringify(includes)}` : ``
  }`;
  const response = await getAuthenticated(
    `/plants/${plantId}/cycles/${cycleId}${meta}`
  );
  return response.payload;
}
async function saveCycle(plantId, cycle) {
  try {
    cycle.plant_id = plantId;
    const response = cycle?.id
      ? await putAuthenticated(
          `/plants/${plantId}/cycles/${cycle.id}`,
          JSON.stringify({ payload: cycle }),
          {
            "Content-Type": "application/json",
          }
        )
      : await postAuthenticated(
          `/plants/${plantId}/cycles`,
          JSON.stringify({ payload: cycle }),
          {
            "Content-Type": "application/json",
          }
        );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getCycles(plantId, query, variables) {
  try {
    const response = await queryAuthenticated("/graphql", query, variables);
    return response.data.cycles;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}

async function deleteCycle(plantId, cycleId) {
  try {
    const response = await deleteAuthenticated(
      `/plants/${plantId}/cycles/${cycleId}`,
      {
        "Content-Type": "application/json",
      }
    );
    return response;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
/*****End Cycle*****/

/*****Start Cycle Stage*****/
async function getCycleStage(plantId, cycleId, cycleStageId, includes) {
  const meta = `${
    includes && includes.length > 0 ? `?meta=${JSON.stringify(includes)}` : ``
  }`;
  const response = await getAuthenticated(
    `/plants/${plantId}/cycles/${cycleId}/cycle-stages/${cycleStageId}${meta}`
  );
  return response.payload;
}
async function saveCycleStage(plantId, cycleId, cycleStage) {
  try {
    cycleStage.plant_id = plantId;
    cycleStage.cycle_id = cycleId;
    const response = cycleStage?.id
      ? await putAuthenticated(
          `/plants/${plantId}/cycles/${cycleId}/cycle-stages/${cycleStage.id}`,
          JSON.stringify({ payload: cycleStage }),
          {
            "Content-Type": "application/json",
          }
        )
      : await postAuthenticated(
          `/plants/${plantId}/cycles/${cycleId}/cycle-stages`,
          JSON.stringify({ payload: cycleStage }),
          {
            "Content-Type": "application/json",
          }
        );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function getCycleStages(plantId, cycleId, includes) {
  try {
    let url = `/plants/${plantId}/cycles/${cycleId}/cycle-stages`;
    if (includes && includes.length > 0) {
      url += `?meta=${encodeURI(JSON.stringify(includes))}`;
    }
    const response = await getAuthenticated(url);
    return response.payload.data;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
async function deleteCycleStage(plantId, cycleId, cycleStageId) {
  try {
    const response = await deleteAuthenticated(
      `/plants/${plantId}/cycles/${cycleId}/cycle-stages/${cycleStageId}`,
      {
        "Content-Type": "application/json",
      }
    );
    return response;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
/*****End CycleStage*****/

/*****Start Activity*****/
async function getActivities(plantId, includes, sortOn, sortOrder, page) {
  try {
    const qsArray = [];
    if (includes && includes.length > 0) {
      qsArray.push(`meta=${JSON.stringify(includes)}`);
    }
    if (sortOn && sortOn.length > 0) {
      qsArray.push(`sort_on=${sortOn}`);
    }
    if (sortOrder && sortOrder.length > 0) {
      qsArray.push(`sort_order=${sortOrder}`);
    }
    if (page > 0) {
      qsArray.push(`page=${page}`);
    }
    const qs = qsArray.join("&");
    const response = await getAuthenticated(
      `/plants/${plantId}/activities${qs.length > 0 ? `?${qs}` : ""}`
    );
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}

async function getNextActivities(url) {
  try {
    const response = await getAuthenticated(url);
    return response.payload;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
/*****End Activity*****/

/** reports */
async function getRawData(
  plantId,
  devices,
  from,
  to,
  includes,
  sortOn,
  sortOrder,
  page
) {
  try {
    let url = `/plants/${plantId}/reports/raw-data`;
    if (includes && includes.length > 0) {
      url += `?meta=${encodeURI(JSON.stringify(includes))}`;
    }
    const response = await postAuthenticated(
      url,
      JSON.stringify({
        devices,
        from,
        to,
      }),
      {
        "Content-Type": "application/json",
      }
    );
    return response.payload.data;
  } catch (error) {
    if (error.message === 403) {
      console.log(error);
    }
  }
}
/** end reports */
export {
  proxies,
  authenticate,
  deauthenticate,
  vaildateToken,
  forgotPassword,
  resetPassword,

  /** plants */
  getPlants,
  getPlant,
  createPlant,
  updatePlant,

  /** zones */
  getZones,
  getZone,
  saveZone,
  deleteZone,
  getZoneLinkedDevices,
  addDeviceWithZone,
  removeDeviceWithZone,
  /** devices */
  getDevices,
  getDevice,
  saveDevice,
  deleteDevice,
  getDeviceLinkedZones,
  addZoneWithDevice,
  removeZoneWithDevice,
  /** channels */
  saveChannel,
  getChannels,
  getChannel,
  /** users */
  getUsers,
  getUser,
  saveUser,
  deleteUser,
  getTimeZones,
  getUserLinkedShifts,
  addShiftWithUser,
  removeShiftWithUser,
  getUserLinkedPlants,
  getUserLinkedRoles,
  addUserWithPlantRole,
  removeUserWithPlantRole,
  /** shifts */
  getShifts,
  getDynamicShifts,
  getShift,
  saveShift,
  deleteShift,
  getShiftLinkedUsers,
  addUserWithShift,
  removeUserWithShift,
  /** roles */
  getRoles,
  getRole,
  saveRole,
  deleteRole,
  getRoleLinkedPermissions,
  addPermissionWithRole,
  /** devicesProfile */
  getDeviceProfiles,
  getDeviceProfile,
  saveDeviceProfile,
  deleteDeviceProfile,
  /** setting */
  getSettings,
  getSetting,
  saveSetting,
  /** permission */
  getPermissions,
  /** part */
  getParts,
  getPart,
  savePart,
  deletePart,
  /** search */
  Search,
  /** Job Schedule */
  getJobSchedules,
  getJobSchedule,
  saveJobSchedule,
  deleteJobSchedule,
  getJobScheduleLinkedCycleStages,
  addCycleStagesWithJobSchedule,
  /** Webhook */
  getWebhooks,
  getWebhook,
  saveWebhook,
  deleteWebhook,
  /** Types */
  getTypes,
  /** cycle */
  getCycles,
  getCycle,
  saveCycle,
  deleteCycle,
  /** cycle-stage */
  getCycleStages,
  getCycleStage,
  saveCycleStage,
  deleteCycleStage,
  /** activities **/
  getActivities,
  getNextActivities,

  /** reports */
  getRawData,
};
